export default __webpack_public_path__ + "static/media/gallery-wip-emitter-body_01.c9c769a3.jpg";